import USER_TYPES from 'constants/UserTypes';
import { isAdmin, isFinanceAdmin } from './roles';
import { CONFIGURED_FEATURES, featureEnabled } from 'helpers/feature-flags';
const SHIPMENT_SHIPPER_CHANGE_REASON_CODE = 'Auto applied accessorial- Declined due to shipper change';
export function accessorialCanBeInvoiced(job, accessorial) {
    if (accessorial.shipper_cost && accessorial.shipper_cost > 0) {
        const receivable = (job.receivables || [])
            .concat(job.managed_receivables || [])
            .some((r) => r.accessorial_request_id &&
            accessorial._id &&
            r.accessorial_request_id.toString() === accessorial._id.toString() &&
            !r.processed);
        return !(receivable || accessorial.shipper_status !== 'approved');
    }
    return false;
}
export function accessorialPaid(job, accessorial) {
    const payable = (job.payables || [])
        .concat(job.managed_payables || [])
        .find((r) => r.accessorial_request_id &&
        accessorial._id &&
        r.accessorial_request_id.toString() === accessorial._id.toString());
    return !!(payable && payable.processed);
}
export function accessorialProcessed(job, accessorial) {
    return (accessorialCanBeInvoiced(job, accessorial) ||
        accessorialPaid(job, accessorial));
}
export function allAccessorialsProcessed(job, accessorials) {
    return accessorials.every((acc) => accessorialProcessed(job, acc._id));
}
export const userCanApproveAccessorials = (user, accessorials) => {
    const existAutodeclinedAccessorial = accessorials.some((a) => a.autodeclined);
    if (!existAutodeclinedAccessorial) {
        return true;
    }
    return isAdmin(user);
};
export const mapProcessedAccessorialLedgerItem = (accessorial, ledger) => {
    var _a, _b;
    if (!accessorial || !ledger)
        return false;
    const accessorial_status = ledger === 'receivables'
        ? accessorial === null || accessorial === void 0 ? void 0 : accessorial.shipper_status
        : accessorial === null || accessorial === void 0 ? void 0 : accessorial.carrier_status;
    if (['pending', 'accept', 'decline'].some((item) => accessorial_status === null || accessorial_status === void 0 ? void 0 : accessorial_status.toLocaleLowerCase().includes(item)))
        return false;
    const ledgerItems = (_b = (_a = accessorial === null || accessorial === void 0 ? void 0 : accessorial.shipment) === null || _a === void 0 ? void 0 : _a[ledger]) === null || _b === void 0 ? void 0 : _b.filter((item) => (item === null || item === void 0 ? void 0 : item.accessorial_request_id) === (accessorial === null || accessorial === void 0 ? void 0 : accessorial._id));
    if (!(ledgerItems === null || ledgerItems === void 0 ? void 0 : ledgerItems.length))
        return false;
    return ledgerItems.every((item) => item === null || item === void 0 ? void 0 : item.processed);
};
export const checkProcessedAccessorial = (accessorial) => {
    if (!accessorial)
        return false;
    const accessorialInProcessedPayout = mapProcessedAccessorialLedgerItem(accessorial, 'payables');
    const accessorialInProcessedInvoice = mapProcessedAccessorialLedgerItem(accessorial, 'receivables');
    return accessorialInProcessedPayout && accessorialInProcessedInvoice;
};
export const checkIfAccessorialAutoDeclined = (accessorial = {}) => {
    const isFeatureEnabled = featureEnabled(CONFIGURED_FEATURES === null || CONFIGURED_FEATURES === void 0 ? void 0 : CONFIGURED_FEATURES.AUTO_APPLY_ACCESSORIAL);
    // Return false if feature flag or not an auto apply accessorial
    if (!isFeatureEnabled || !(accessorial === null || accessorial === void 0 ? void 0 : accessorial.auto_applied))
        return false;
    const { carrier_status, shipper_status, shipper_decline_reason_code, carrier_decline_reason_code, } = accessorial;
    const declineReason = SHIPMENT_SHIPPER_CHANGE_REASON_CODE, status = 'declined';
    return (carrier_status === status &&
        shipper_status === status &&
        shipper_decline_reason_code === declineReason &&
        carrier_decline_reason_code === declineReason);
};
export const checkWhichSideAccessorialAutoDeclined = (accessorial = {}, userType = 'shipper') => {
    const isFeatureEnabled = featureEnabled(CONFIGURED_FEATURES === null || CONFIGURED_FEATURES === void 0 ? void 0 : CONFIGURED_FEATURES.AUTO_APPLY_ACCESSORIAL);
    // Return false if feature flag or not an auto apply accessorial
    if (!isFeatureEnabled || !(accessorial === null || accessorial === void 0 ? void 0 : accessorial.auto_applied))
        return false;
    const { carrier_status, shipper_status, shipper_decline_reason_code, carrier_decline_reason_code, } = accessorial;
    const declineReason = SHIPMENT_SHIPPER_CHANGE_REASON_CODE, status = 'declined';
    // Check for shipper side
    if (userType === 'shipper') {
        return (shipper_status === status && shipper_decline_reason_code === declineReason);
    }
    // Check for carrier side
    if (userType === 'carrier') {
        return (carrier_status === status && carrier_decline_reason_code === declineReason);
    }
    return false;
};
export const checkIfAccessorialsNeedsReview = (accessorials = []) => {
    return !!accessorials.find((accessorial) => {
        const { auto_applied = false, needs_review = false } = accessorial;
        return auto_applied && needs_review;
    });
};
export const checkIfEquipmentIsMissing = (accessorials = []) => {
    return !!accessorials.find((accessorial) => {
        const { equipment_id = [] } = accessorial;
        return equipment_id.length === 0;
    });
};
export const checkIfEquipmentIsMissingForAccessorial = (accessorial = {}) => {
    var _a;
    return !((_a = accessorial === null || accessorial === void 0 ? void 0 : accessorial.equipment_id) === null || _a === void 0 ? void 0 : _a.length);
};
export const isCarrierMissingInAccessorial = (accessorial = {}) => {
    const { carrier, payee_type } = accessorial;
    if (payee_type !== 'carrier')
        return false;
    return !carrier;
};
export const getCarrierAccordionTitle = (carrierMissing = false, carrierMismatch = false) => {
    if (carrierMissing && carrierMismatch)
        return 'carrier_mismatch_and_missing';
    if (carrierMissing)
        return 'carrier_missing';
    if (carrierMismatch)
        return 'carrier_mismatch';
    return '';
};
